import React from 'react';
import { Spinner } from '@pb/shared/ui/atoms/spinner';
import { Paragraph } from '@pb/shared/ui/atoms/paragraph';
import { NotificationContainerDiv } from './loading-notification.styled';

export const LoadingNotification = () => {
    return (
        <NotificationContainerDiv>
            <Spinner size={24} color="grey6" />
            <Paragraph color="grey6">Loading messages</Paragraph>
        </NotificationContainerDiv>
    );
};
